import type React from "react";

interface Props {
  children: React.ReactNode;
  styles: React.CSSProperties[];
}

export const DesingConteiner = ({ children, styles }: Props): JSX.Element => {
  return (
    <div
      className="col-12 d-flex flex-column justify-content-end align-items-center"
      style={Object.assign({}, ...styles)}>
      {children}
    </div>
  );
};
